import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
export var DataListItemRow = function DataListItemRow(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$rowid = _a.rowid,
      rowid = _a$rowid === void 0 ? '' : _a$rowid,
      props = __rest(_a, ["children", "className", "rowid"]);

  return React.createElement("div", Object.assign({
    className: css(styles.dataListItemRow, className)
  }, props), React.Children.map(children, function (child) {
    return React.isValidElement(child) && React.cloneElement(child, {
      rowid: rowid
    });
  }));
};